const STEAL_DEAL_WIDGET_PREFIX = "steal-deal-widget";

export const STEAL_DEAL_WIDGET_TEST_IDS = {
    // Main widget container
    CONTAINER: `${STEAL_DEAL_WIDGET_PREFIX}-container`,

    // Widget states
    LOCKED_STATE: `${STEAL_DEAL_WIDGET_PREFIX}-locked-state`,
    UNLOCKED_STATE: `${STEAL_DEAL_WIDGET_PREFIX}-unlocked-state`,

    // Text elements
    TITLE: `${STEAL_DEAL_WIDGET_PREFIX}-title`,
    SUBTITLE: `${STEAL_DEAL_WIDGET_PREFIX}-subtitle`,

    // Item details
    ITEM_NAME: `${STEAL_DEAL_WIDGET_PREFIX}-item-name`,
    ITEM_ORIGINAL_PRICE: `${STEAL_DEAL_WIDGET_PREFIX}-item-original-price`,
    ITEM_FREE_TEXT: `${STEAL_DEAL_WIDGET_PREFIX}-item-free-text`,

    // Claim button
    CLAIM_BUTTON: `${STEAL_DEAL_WIDGET_PREFIX}-claim-button`,
    CLAIM_BUTTON_TEXT: `${STEAL_DEAL_WIDGET_PREFIX}-claim-button-text`,
};
